export default "__VITE_ASSET__BB9_w4hh__"